import React, { useEffect } from 'react'
import { setDarkColor, setLightColor } from "./theme"
import { Router } from "./router"
import { useColorMode } from '@chakra-ui/react'
import BetaNotif from './pages/MainApp/BetaNotif'

const App = () => {
    const { colorMode } = useColorMode()

    useEffect(() => {
        if (colorMode === 'light') {
            setLightColor()
        } else {
            setDarkColor()
        }
    }, [colorMode])

    return (
        <React.Fragment>
            {/* <HotjarProvider /> */}
            <Router />
            <BetaNotif />
        </React.Fragment>
    )
}

export default App
